var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.type)?_c('a',{key:"normalbutton",staticClass:"btn",class:_vm.color,attrs:{"href":_vm.link}},[_vm._v(_vm._s(_vm.label))]):_vm._e(),(!_vm.type)?_c('router-link',{key:"routerbutton",staticClass:"btn",class:_vm.color,attrs:{"to":_vm.link}},[_vm._v(_vm._s(_vm.label))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }